import { InfrastructureError } from '@goodt-wcore/errors';

/**
 * Enum ошибок апи-сервиса
 * @readonly
 */
export const ApiServiceErrorCode = Object.freeze({
    INTERNAL: 'internal',
    VALIDATION: 'validation',
    FORBIDDEN: 'forbidden',
    NOT_FOUND: 'not_found',
    UNAUTHORIZED: 'unauthorized',
    UNKNOWN: 'unknown',
    CONFLICT: 'conflict'
});

/**
 * Класс-исключение транспортного уровня для запросов к api
 * @class ApiServiceError
 */
class ApiServiceError extends InfrastructureError {
    /**
     *
     * @type {typeof ApiServiceErrorCode}
     */
    static Code = ApiServiceErrorCode;

    constructor(message, { code, data, reason } = {}) {
        super(message, { code, data, reason });
        this.name = 'ApiServiceError';
    }
}

export { ApiServiceError, ApiServiceError as default };
